// @flow
'use strict';

import Modal from './modais/index';

export default Modal;
